import config from '../utils/config'
import request from '../utils/request'

const {api} = config
const { promotes, promoteOne, promoteOneLogo } = api

/**
 * 查找列表
 */
export async function findPromotes(params) {
    return request({url:promotes, method: 'get', data: params,})
}

/**
 * 新增渠道
 */
export async function createPromotes(params) {
    return request({url:promotes, method: 'post', data: params})
}

/**
 * 更新
 */
export async function updatePromotes(params) {
    return request({url:promoteOne, method: 'put', data: params})
}
/**
 * 删除
 */
export async function deletePromotes(params) {
    return request({url:promoteOne, method: 'delete', data: params})
}

/**
 * 更新logo
 */
export async function updatePromotesLogo(params) {
    return request({url:promoteOneLogo+'?logo='+params.logo, method: 'put', data: params})
}




// WEBPACK FOOTER //
// ./src/services/promote.js